import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TICKET_NUMBER: {
        id: 'claims.export.form.ticketNumber',
        defaultMessage: 'Ticket No.'
    },
    ASSIGNED: {
        id: 'claims.export.form.assigned',
        defaultMessage: 'Assigned to'
    },
    DATE_FROM: {
        id: 'claims.export.form.dateFrom',
        defaultMessage: 'Date From'
    },
    DATE_TO: {
        id: 'claims.export.form.dateTo',
        defaultMessage: 'Date To'
    },
    DEALER_NAME: {
        id: 'claims.export.form.dealerName',
        defaultMessage: 'Dealer Name'
    },
    DEALER_NUMBER: {
        id: 'claims.export.form.dealerNumber',
        defaultMessage: 'Dealer No.'
    },
    STATUS: {
        id: 'claims.export.form.status',
        defaultMessage: 'Status'
    },
    TYPE: {
        id: 'claims.export.form.type',
        defaultMessage: 'Type'
    },
    LAST_EXPORT: {
        id: 'claims.export.form.lastExport',
        defaultMessage: 'Last export:'
    },
    EXPORT_STATUS: {
        id: 'claims.export.form.exportStatus',
        defaultMessage: 'Export status:'
    },
    XLS: {
        id: 'claims.export.form.xls',
        defaultMessage: 'XLS'
    },
    CSV: {
        id: 'claims.export.form.csv',
        defaultMessage: 'CSV'
    }
});

export default messages;
